import { Props } from "."

export const mockProps: Props = {
  children: "Master the fundamentals of cybersecurity",
  size: "lg",
  className: "w-full",
}
